module.exports = __webpack_public_path__ + "static/media/iP-Cam.9ad52af8.png";